module.exports = __webpack_public_path__ + "img/title-@2x.cd5d1b78.png";